import { render, staticRenderFns } from "./AgDataTableNew.vue?vue&type=template&id=20f96e5f"
import script from "./AgDataTableNew.vue?vue&type=script&lang=js"
export * from "./AgDataTableNew.vue?vue&type=script&lang=js"
import style0 from "./AgDataTableNew.vue?vue&type=style&index=0&id=20f96e5f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports